import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RegistroCortoComponent } from './candidato/registro-corto/registro-corto.component';
import { HomeComponent } from './candidato/home/home.component';
import { ValidacionEmailComponent } from './notificaciones/validacion-email/validacion-email.component';
import { RegistroExitosoComponent } from './notificaciones/registro-exitoso/registro-exitoso.component';
import { SearchJobComponent } from './candidato/search-job/search-job.component';
import { LoginComponent } from './candidato/login/login.component';
import { ResetPasswordComponent } from './candidato/reset-password/reset-password.component';
import { SolicitudResetPasswordComponent } from './candidato/solicitud-reset-password/solicitud-reset-password.component';
import { PostulacionComponent } from './candidato/postulacion/postulacion.component';

import { CandidatoPerfilComponent } from './candidato/candidato-perfil/candidato-perfil.component';
import { CargaCvComponent } from './candidato/carga-cv/carga-cv.component';
import { OpcionesRegistroComponent } from './candidato/opciones-registro/opciones-registro.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const routes: Routes = [
  //{ path: '', component: PrincipalComponent },
  // { path: '**', redirectTo: 'registro-corto', pathMatch: 'full' },

  // Registro corto
  // { path: '', component: RegistroCortoComponent, pathMatch: 'full' },
  // { path: 'registro-corto', component: RegistroCortoComponent },
  // { path: 'registro-exitoso', component: RegistroExitosoComponent },
  // { path: 'validacion-email', component: ValidacionEmailComponent },

  // All site
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'opciones-registro', component: OpcionesRegistroComponent },
  { path: 'registro-corto', component: RegistroCortoComponent },
  { path: 'login', component: LoginComponent },
  { path: 'solicitud-cambio-credenciales', component: SolicitudResetPasswordComponent },
  { path: 'cambio-credenciales', component: ResetPasswordComponent },
  { path: 'registro-exitoso', component: RegistroExitosoComponent },
  { path: 'validacion-email', component: ValidacionEmailComponent },
  //{ path: 'postulacion/:id', component: PostulacionComponent, canActivate: [AuthGuard] },
  { path: 'postulacion/:id', component: PostulacionComponent},
  { path: 'buscador', component: SearchJobComponent },
  { path: 'candidato-perfil', component: CandidatoPerfilComponent },
  { path: 'registro-cv', component: CargaCvComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
